(() => {
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’'.,&()\-]/g, ' ').replace(/\s+/g, ' ').trim();
  function initialize(root) {
    root.querySelectorAll('[data-hkg-country-picker]').forEach(picker => {
      if (picker.dataset.enhanced) return;
      const select = picker.querySelector('select');
      const section = picker.closest('.hkgq');
      const sid = select.id.replace(/^Hkg(?:Origin|Destination)-/, '');
      const catalogue = JSON.parse(document.getElementById('HkgCountries-' + sid).textContent);
      const labels = JSON.parse(document.getElementById('HkgCountryLabels-' + sid).textContent);
      const byCode = new Map(catalogue.map(country => [country.code, country]));
      const choices = Array.from(select.options).filter(option => option.value !== '').map(option => {
        const country = byCode.get(option.dataset.countryCode);
        if (!country) throw new Error('Missing country ' + option.dataset.countryCode);
        return {value:option.value, title:option.textContent.trim(), country, search:[country.en, country.zhHant, country.zhHans, country.code, country.title, ...country.aliases].map(normalize)};
      }).sort((a,b) => a.country.en.localeCompare(b.country.en, 'en'));
      const control = document.createElement('div');
      control.className = 'hkgq__countryControl';
      const input = document.createElement('input');
      input.type = 'text';
      input.id = select.id + '-Search';
      input.placeholder = labels.search;
      input.autocomplete = 'off';
      input.spellcheck = false;
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-haspopup', 'listbox');
      input.setAttribute('aria-labelledby', picker.dataset.label);
      input.setAttribute('aria-controls', select.id + '-List');
      const clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'hkgq__countryClear';
      clear.textContent = '×';
      clear.setAttribute('aria-label', labels.clear);
      clear.hidden = true;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'hkgq__countryToggle';
      toggle.textContent = '⌄';
      toggle.tabIndex = -1;
      toggle.setAttribute('aria-label', labels.open);
      const panel = document.createElement('div');
      panel.className = 'hkgq__countryPanel';
      panel.hidden = true;
      const count = document.createElement('div');
      count.className = 'hkgq__countryCount';
      count.setAttribute('role', 'status');
      count.setAttribute('aria-live', 'polite');
      const list = document.createElement('div');
      list.className = 'hkgq__countryList';
      list.id = select.id + '-List';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-labelledby', picker.dataset.label);
      panel.append(count, list);
      control.append(input, clear, toggle);
      picker.append(control, panel);
      select.hidden = true;
      picker.dataset.enhanced = 'true';
      let matches = choices, active = -1, composing = false;
      function notify() {
        select.dispatchEvent(new Event('input', {bubbles:true}));
        select.dispatchEvent(new Event('change', {bubbles:true}));
      }
      function sync() {
        input.value = choices.find(choice => choice.value === select.value)?.title || '';
        clear.hidden = !input.value;
      }
      function highlight(index, scroll = true) {
        active = matches.length ? Math.max(0, Math.min(index, matches.length - 1)) : -1;
        Array.from(list.children).forEach((item, i) => item.classList.toggle('is-active', i === active));
        if (active < 0) {input.removeAttribute('aria-activedescendant'); return;}
        const item = list.children[active];
        input.setAttribute('aria-activedescendant', item.id);
        if (scroll) item.scrollIntoView({block:'nearest',inline:'nearest'});
      }
      function render(query = '') {
        const term = normalize(query);
        matches = choices.filter(choice => !term || (/^[a-z]$/.test(term) ? normalize(choice.country.en).startsWith(term) : choice.search.some(text => text.includes(term))));
        list.replaceChildren();
        matches.forEach((choice, index) => {
          const item = document.createElement('div');
          item.className = 'hkgq__countryOption';
          item.id = select.id + '-Option-' + index;
          item.dataset.index = String(index);
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', String(choice.value === select.value));
          item.textContent = choice.title;
          list.append(item);
        });
        count.textContent = matches.length ? labels.count.replace('__COUNT__', String(matches.length)) : labels.empty;
        list.hidden = matches.length === 0;
        list.scrollTop = 0;
        highlight(term ? 0 : matches.findIndex(choice => choice.value === select.value), false);
      }
      function open(query = '') {
        if (picker.hidden) return;
        section.dispatchEvent(new CustomEvent('hkgship:country-open', {detail:picker}));
        render(query);
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      function close() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        sync();
      }
      function choose(index) {
        const choice = matches[index];
        if (!choice) return;
        select.value = choice.value;
        notify();
        close();
      }
      function filter() {
        if (composing) return;
        const query = input.value;
        if (select.value) {select.value = ''; notify();}
        input.value = query;
        clear.hidden = !input.value;
        open(query);
      }
      input.addEventListener('focus', () => {open(); input.select();});
      input.addEventListener('click', () => {if (panel.hidden) {open(); input.select();}});
      input.addEventListener('input', filter);
      input.addEventListener('compositionstart', () => {composing = true;});
      input.addEventListener('compositionend', () => {composing = false; filter();});
      input.addEventListener('keydown', event => {
        if (composing || event.isComposing) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const wasClosed = panel.hidden;
          if (wasClosed) open(select.value ? '' : input.value);
          highlight(wasClosed ? (event.key === 'ArrowDown' ? 0 : matches.length - 1) : active + (event.key === 'ArrowDown' ? 1 : -1));
        } else if (event.key === 'Enter' && !panel.hidden) {
          event.preventDefault(); choose(active);
        } else if (event.key === 'Escape') {
          event.preventDefault(); close();
        } else if (event.key === 'Tab') close();
      });
      list.addEventListener('pointerdown', event => event.preventDefault());
      list.addEventListener('click', event => {
        const item = event.target.closest('[data-index]');
        if (item) choose(Number(item.dataset.index));
      });
      toggle.addEventListener('pointerdown', event => event.preventDefault());
      toggle.addEventListener('click', () => {
        if (!panel.hidden) {close(); return;}
        input.focus(); open(); input.select();
      });
      clear.addEventListener('click', () => {
        select.value = ''; sync(); notify(); input.focus(); open();
      });
      picker.addEventListener('focusout', event => {if (!picker.contains(event.relatedTarget)) close();});
      document.addEventListener('pointerdown', event => {if (!picker.contains(event.target)) close();});
      section.addEventListener('hkgship:country-open', event => {if (event.detail !== picker) close();});
      section.addEventListener('hkgship:direction-change', close);
      select.addEventListener('change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
